import React, { useState } from "react";
import axios from "axios";

function DividorDropdown({ dividors, user, setDecks, setDividors }) {
  const [open, setOpen] = useState(false);

  const handleSelect = async (dividor) => {
    setOpen(false);
    if (!dividor) {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/data/snapDecks/user/${user.id}`
      );
      setDecks(res.data || []);
      return;
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/data/snapDecks/user/${user.id}/dividor/${encodeURIComponent(dividor)}`
      );
      setDecks(res.data || []);
    } catch (err) {
      console.error("Failed to fetch decks by dividor:", err);
    }
  };

  const handleDelete = async (div) => {
    if (!window.confirm(`Delete dividor "${div.dividor}"?`)) return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/deleteSnapDividor/${div.id}`
        );

      // Reset decks that had this dividor to Neutral
      setDecks((prev) =>
        prev.map((d) =>
          d.dividor === div.dividor ? { ...d, dividor: "Neutral" } : d
        )
      );

      // Remove from local state
      setDividors((prev) => prev.filter((x) => x.id !== div.id));
    } catch (err) {
      console.error("Failed to delete dividor:", err);
      alert("Could not delete dividor.");
    }
  };

  return (
    <div style={{ display: "inline-block", position: "relative", marginRight: "10px" }}>
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            background: "#222",
            border: "1px solid #444",
            borderRadius: "6px",
            marginTop: "4px",
            zIndex: 20,
            width: "100%",
          }}
        >
          {/* View all option */}
          <div
            style={{
              padding: "6px 8px",
              cursor: "pointer",
              borderBottom: "1px solid #333",
            }}
            onClick={() => handleSelect("")}
          >
            View All Decks
          </div>

          {/* List dividors with delete buttons */}
          {dividors.map((div) => (
            <div
              key={div.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 8px",
                borderBottom: "1px solid #333",
              }}
            >
              <span
                style={{ cursor: "pointer", flex: 1 }}
                onClick={() => handleSelect(div.dividor)}
              >
                {div.dividor}
              </span>
              <button
                className="button"
                style={{
                  background: "#b33",
                  padding: "2px 6px",
                  fontSize: "0.8rem",
                  marginLeft: "6px",
                }}
                onClick={() => handleDelete(div)}
              >
                ❌
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DividorDropdown;
